export enum Breakpoint {
  XXS = 320,
  XS = 380,
  SM = 640,
  MD = 768,
  LG = 1024,
  XL = 1280,
  XXL = 1536,
}
